// The India region's Supabase project (Altekore_IN). Public values: the project address and its publishable key.
// Override with VITE_SUPABASE_URL / VITE_SUPABASE_KEY (e.g. a local Supabase) when developing.
export const CONFIG = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL ?? "https://jqidbbgaxnxnjphahigm.supabase.co",
  supabaseKey: import.meta.env.VITE_SUPABASE_KEY ?? "sb_publishable_8K4RMgmE_EYUaHVYvZnq_A_6q7aOYjY",
  apiSchema: "books_api",
  // legal pages (inside the app, web/src/legal) and support
  termsUrl: import.meta.env.VITE_TERMS_URL ?? "/legal/terms",
  privacyUrl: import.meta.env.VITE_PRIVACY_URL ?? "/legal/privacy",
  supportEmail: import.meta.env.VITE_SUPPORT_EMAIL ?? "support@altekore.in",
  // Altekore Accounts: where people sign in and manage their profile, password and two-step sign-in (accounts/)
  accountsUrl: import.meta.env.VITE_ACCOUNTS_URL ?? "https://accounts.altekore.in",
  // on Altekore's domains, sign-in and the profile are in Altekore Accounts (VITE_ACCOUNTS_ON=0 turns that off)
  accountsOn: (import.meta.env.VITE_ACCOUNTS_ON ?? "1") === "1",
} as const;
